import { AxiosResponse } from 'axios'

import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { ISingleAudience } from '@typings'

export class AudienceService extends AxiosBaseApi {
  getSingle = (slug: ISingleAudience['slug']) =>
    this.api
      .get<AxiosResponse<{ data: ISingleAudience }>>(
        ENDPOINTS.AUDIENCE.SINGLE(slug),
      )
      .then(response => response.data.data)
}
